import { Grid } from '@material-ui/core'
import { useFormikContext } from 'formik'
import { AliquotaIcmsInput } from 'src/components/AliquotaIcmsInput'
import NumericInput from 'src/components/Formik/Forms/NumericInput'
import SwitchInput from 'src/components/SwitchInput'
import { ProgramacaoFormData } from '../../types/formData'
import { DestinosInput } from './DestinosInput'
import { OrigemInput } from './OrigemInput'
import { PernaTypography } from './PernaTypography'
import { SimularFreteButton } from './SimularFreteAdornment'
import { ColetaEntregaProps } from './types'

export const ColetaEntregaGrupo = ({
  multiplasEntregas,
  pernaIndex,
  isLastPerna,
  namePrefix,
  tabelaId
}: ColetaEntregaProps) => {
  const formik = useFormikContext<ProgramacaoFormData>()
  const [, loteId, , index] = namePrefix.split('.')

  return (
    <PernaTypography pernaIndex={pernaIndex}>
      <Grid container spacing={2}>
        <OrigemInput namePrefix={namePrefix} />

        <Grid item xs={12}>
          <DestinosInput
            name={`${namePrefix}.destinos`}
            multiplasEntregas={multiplasEntregas}
            pernaIndex={pernaIndex}
            isLastPerna={isLastPerna}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            spacing={3}
          >
            <Grid item xs={10}>
              <NumericInput
                name={`${namePrefix}.freteEmpresa`}
                label="Frete Empresa"
              />
            </Grid>
            <Grid item xs={2}>
              <SimularFreteButton
                tabelaId={tabelaId}
                pernaIndex={pernaIndex}
                loteId={loteId}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={3}>
          <NumericInput
            name={`${namePrefix}.valorPedagio`}
            label="Valor Pedágio"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <AliquotaIcmsInput name={`${namePrefix}.aliquotaIcms`} />
        </Grid>

        <Grid item xs={12} md={3}>
          <SwitchInput
            name={`${namePrefix}.freteGrupoDiferente`}
            label="Frete Grupo Diferente 3%"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <div
            hidden={
              !formik.values.lotes[loteId].pernas[+index].freteGrupoDiferente
            }
          >
            <NumericInput
              name={`${namePrefix}.freteGrupo`}
              label="Frete Grupo"
            />
          </div>
        </Grid>
      </Grid>
    </PernaTypography>
  )
}
